import getLocationRouterSelect from 'modules/router/selectors/get-location'
import { createSelector } from 'reselect'

const getSearchRouterSelect = createSelector(
  getLocationRouterSelect,
  (location) => location ? location.search : ''
)

export default getSearchRouterSelect
